export enum UnitType {
  METRIC = 'METRIC',
  IMPERIAL = 'IMPERIAL',
  NAUTICAL = 'NAUTICAL',
}
